export const DEFAULT_THEMES = {
    Z_INDEX: { mobileStepper: 100, fab: 105, speedDial: 105, appBar: 110, drawer: 120, modal: 130, snackbar: 140, tooltip: 150 },
    APP_BAR: { width: 240, headerHeight: '64px', enableMenu: true, menuPosition: 'right', backPosition: 'left', enableBack: true },
    TOOL_BAR: { height: '11vh' }
};

export const ENV_TYPES = {
    LOCAL: 'local',
    DEV: 'dev',
    PROD: 'prod'
};

export const PLUGIN_TYPES = {
    WALL_PAPER: 'wall-paper',
    E_SHOP: 'e-shop',
    BOOKING: 'booking'
};

export const GA_UTM_CAMPAIGN = '';
export const GA_UTM_MEDIUM = '';
export const GA_UTM_SOURCE = '';
export const GA_CATEGORY = '';

export const LIFF_HOST_URL = `https://liff.line.me/${process.env.REACT_APP_LIFF_ID}`;

export const s3Url = 'https://d2zayvicus4xl7.cloudfront.net/tag-heuer-rsvp';
